var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Inset, Stack } from 'syf-component-library/ui/spacing';
import { translate } from '../../strings/i18n';
import CurrentPaymentDueDate from './utils/CurrentPaymentDueDate';
import { ContentWrapper, HeaderTitle, HeaderWrapper, Image, ImageContainer, SelectTheDate } from './subcomponents';
import { ChangePaymentDueDateScreen } from '../../typings';
import MessageBox from '../MessageBox';
import Icon from '../icon';
import { FAS_EXCLAMATION_TRIANGLE } from '../../../../const/icon-props';
import useGetImages from '../../hooks/useGetImages';
var ChangePaymentDueDateHeader = function (_a) {
    var date = _a.date, currentScreen = _a.currentScreen;
    var calendar = useGetImages().calendar;
    return (_jsx(ContentWrapper, __assign({ "data-testid": "change-payment-due-date-header" }, { children: _jsxs(HeaderWrapper, __assign({ horizontal: "medium", hideOnBreakpointUp: "medium" }, { children: [_jsx(Stack, { hideOnBreakpointDown: "medium", size: "small" }), _jsx(ImageContainer, __assign({ horizontal: "xlarge" }, { children: _jsx(Image, { src: calendar, alt: "calendar-image" }) })), _jsx(HeaderTitle, __assign({ weight: "bold" }, { children: translate('header.title') })), _jsx(Inset, __assign({ horizontal: "base" }, { children: _jsx(CurrentPaymentDueDate, { date: date }) })), _jsx(SelectTheDate, { children: translate('header.selectTheDate') }), currentScreen &&
                    currentScreen ===
                        ChangePaymentDueDateScreen.SELECT_DAY_ERROR_SCREEN && (_jsxs(_Fragment, { children: [_jsx(Stack, { size: "large" }), _jsx(MessageBox, { type: "error", icon: _jsx(Icon, { title: "exclamation triangle icon", icon: FAS_EXCLAMATION_TRIANGLE, size: "lg" }), body: translate('header.selectDateError') })] })), _jsx(Stack, { hideOnBreakpointDown: "medium", size: "small" })] })) })));
};
export default ChangePaymentDueDateHeader;
